// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"6ff9249e","948":"0b3f5ada"}[chunkId] + ".chunk.css";
};